import {ApiError} from '@spa/api';

import {
    CompanyFormErrorStatesEnum,
    CompanyAddressFormErrorStatesEnum,
    CompanyDocumentsFormErrorStatesEnum,
    CompanyTaxDetailsFormErrorStatesEnum,
    CompanyRegistrationFormErrorStatesEnum
} from '../../enums';

export class CompanyRegistrationTrait {
    private constructor() {
    }

    static getMappedCompanyErrors(errors: ApiError[]): ApiError[] {
        return errors.map((error: ApiError) => {
            switch (error.status) {
                case CompanyFormErrorStatesEnum.CompanyRegistrationFailed:
                    return new ApiError(CompanyRegistrationFormErrorStatesEnum.CompanyRegistrationFailed);
                case CompanyFormErrorStatesEnum.GetCompanyFailed:
                    return new ApiError(CompanyRegistrationFormErrorStatesEnum.GetCompanyFailed);
                default:
                    return error;
            }
        });
    }

    static getMappedTaxDetailsErrors(errors: ApiError[]): ApiError[] {
        return errors.map((error: ApiError) => {
            switch (error.status) {
                case CompanyTaxDetailsFormErrorStatesEnum.UpdateTaxDetailsFailed:
                    return new ApiError(CompanyRegistrationFormErrorStatesEnum.TaxDetailsUpdateFailed);
                case CompanyTaxDetailsFormErrorStatesEnum.TaxDetailsRegistrationFailed:
                    return new ApiError(CompanyRegistrationFormErrorStatesEnum.TaxDetailsRegistrationFailed);
                default:
                    return error;
            }
        });
    }

    static getMappedResidentialAddressErrors(errors: ApiError[]): ApiError[] {
        return errors.map((error: ApiError) => {
            switch (error.status) {
                case CompanyAddressFormErrorStatesEnum.UpdateAddressFailed:
                    return new ApiError(
                        CompanyRegistrationFormErrorStatesEnum.UpdateResidentialAddressFailed
                    );
                case CompanyAddressFormErrorStatesEnum.AddressRegistrationFailed:
                    return new ApiError(
                        CompanyRegistrationFormErrorStatesEnum.ResidentialAddressRegistrationFailed
                    );
                default:
                    return error;
            }
        });
    }

    static getMappedMailingAddressErrors(errors: ApiError[]): ApiError[] {
        return errors.map((error: ApiError) => {
            switch (error.status) {
                case CompanyAddressFormErrorStatesEnum.UpdateAddressFailed:
                    return new ApiError(
                        CompanyRegistrationFormErrorStatesEnum.UpdateMailingAddressFailed
                    );
                case CompanyAddressFormErrorStatesEnum.AddressRegistrationFailed:
                    return new ApiError(
                        CompanyRegistrationFormErrorStatesEnum.MailingAddressRegistrationFailed
                    );
                default:
                    return error;
            }
        });
    }

    static getMappedDocumentErrors(errors: ApiError[]): ApiError[] {
        return errors.map((error: ApiError) => {
            switch (error.status) {
                case CompanyDocumentsFormErrorStatesEnum.UploadFileForRegistrationFailed:
                    return new ApiError(
                        CompanyRegistrationFormErrorStatesEnum.UploadDocumentFileForRegistrationFailed
                    );
                case CompanyDocumentsFormErrorStatesEnum.DocumentRegistrationFailed:
                    return new ApiError(
                        CompanyRegistrationFormErrorStatesEnum.DocumentRegistrationFailed
                    );
                case CompanyDocumentsFormErrorStatesEnum.UploadFileForUpdateFailed:
                    return new ApiError(
                        CompanyRegistrationFormErrorStatesEnum.UploadDocumentFileForUpdateFailed
                    );
                case CompanyDocumentsFormErrorStatesEnum.UpdateDocumentFailed:
                    return new ApiError(
                        CompanyRegistrationFormErrorStatesEnum.UpdateDocumentFailed
                    );
                default:
                    return error;
            }
        });
    }

    static getMappedProofOfAddressDocumentErrors(errors: ApiError[]): ApiError[] {
        return errors.map((error: ApiError) => {
            switch (error.status) {
                case CompanyDocumentsFormErrorStatesEnum.UploadFileForRegistrationFailed:
                    return new ApiError(
                        CompanyRegistrationFormErrorStatesEnum.UploadProofOfAddressDocumentFileForRegistrationFailed
                    );
                case CompanyDocumentsFormErrorStatesEnum.DocumentRegistrationFailed:
                    return new ApiError(
                        CompanyRegistrationFormErrorStatesEnum.ProofOfAddressDocumentRegistrationFailed
                    );
                case CompanyDocumentsFormErrorStatesEnum.UploadFileForUpdateFailed:
                    return new ApiError(
                        CompanyRegistrationFormErrorStatesEnum.UploadProofOfAddressDocumentFileForUpdateFailed
                    );
                case CompanyDocumentsFormErrorStatesEnum.UpdateDocumentFailed:
                    return new ApiError(
                        CompanyRegistrationFormErrorStatesEnum.UpdateProofOfAddressDocumentFailed
                    );
                default:
                    return error;
            }
        });
    }
}
